import { createFromIconfontCN } from '@ant-design/icons'
import { Button, Dropdown, Menu, Modal } from 'antd'
import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import AlertIcon from 'components/icons/AlertIcon'
import ArrowDown from 'components/icons/ArrowDown'
import ManageIcon from 'components/icons/ManageIcon'
import NotificationIcon from 'components/icons/NotificationIcon'
import PluginLiveLogo from 'components/icons/PluginLiveLogo'
import AccountSwitcher from 'components/AccountSwitcher'
import HeaderInstituteInfo from 'modules/Page/Components/Partials/HeaderInstituteInfo'
import Notification from 'modules/Page/Components/Partials/NotificationDrawer/index'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const BREAKPOINT = '999px'

const StyledFlex = styled(Flex)`
  padding: 5px 20px 5px 20px;
  height: 82px;
  width: 100%;
  top: 0;

  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  @media screen and (max-width: ${BREAKPOINT}) {
    padding: 15px 20px 15px 0px !important;
    background: #ffffff;
    margin: 0px !important;
  }
`

const IconWrapper = styled(Flex)`
  background-color: white;
  min-width: 200px;
  max-width: 200px;
  justify-content: center;
`

const Divider = styled.div`
  border-left: 1px solid #e6e7ea;
  margin-right: 25px;
  height: 55px;
`
const FlexDiv = styled(Flex)`
  gap: 20px;
`
export const Outerdiv = styled(Flex)`
  padding: 5px;
  text-align: center;
`
export const NameDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding: 8px;
`
export const EmailDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #808697;
`

export const ManageText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #343e59;
`
export const DropMenu = styled(Menu)`
  width: 300px;
  padding: 10px;
`
export const ManageFlex = styled(Flex)`
  height: 35px;
  padding-top: 8px;
  gap: 8px;
`
export const AdminDiv = styled.div`
  padding: 3px 6px 4px;
  width: 44px;
  height: 17px;
  background: #dff0ea;
  border-radius: 3px;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;
  color: #5db594;
  margin-top: 8px;
`

export const NotificationDiv = styled.div`
  cursor: pointer;
`
export const UserFlex = styled(Flex)`
  cursor: pointer;
`

const Header = ({
  isOnboarding = false,
  userData,
  userRole,
  instituteData,
  getUserNotifications,
  notificationData,
  markNotificationReadApi,
  checkOut,
  signOut,
}) => {
  const [notification, setNotification] = useState(false)

  const CheckUserlogo = (logo, sizevalue) => {
    if (!logo && userData?.first_name) {
      return (
        <Avatar
          background
          size={sizevalue}
          IconName={userData?.first_name[0]?.toUpperCase()}
          font={18}
        />
      )
    } else {
      return <Avatar size={sizevalue} src={userData?.profile_picture} />
    }
  }

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }
  const onLogout = () => {
    confirm({
      title: 'Are you sure you want to Logout ?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        signOut()
      },
    })
  }

  const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
  })
  const { confirm } = Modal

  const handleCheckout = () => {
    confirm({
      title: 'Are you sure you want to Checkout ?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        checkOut(userData?.email)
      },
    })
  }

  const items = (
    <DropMenu
      items={[
        {
          label: (
            <Outerdiv column centerVertically>
              {CheckUserlogo(userData?.profile_picture, 64)}

              <NameDiv>
                {userData?.first_name} {userData?.last_name}
              </NameDiv>
              <EmailDiv>{userData?.email}</EmailDiv>
              <AdminDiv>
                {getRoleName(
                  userData?.pluginlive_id
                    ? userData?.admin?.instRoleId
                    : userData?.admin_role_id ?? userData?.role_id
                )}
              </AdminDiv>
            </Outerdiv>
          ),
          key: '0',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <Link to="/manageprofile">
              <ManageFlex>
                <Avatar src={<ManageIcon />} />
                <ManageText>Manage Profile</ManageText>
              </ManageFlex>
            </Link>
          ),
          key: '1',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <div style={{ maxWidth: '280px', overflow: 'hidden' }}>
              <AccountSwitcher currentJourney="institute" />
            </div>
          ),
          key: '2',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <ManageFlex onClick={() => onLogout()}>
              <Avatar size={36} src={<AlertIcon />} />
              <ManageText>Logout</ManageText>
            </ManageFlex>
          ),
          key: '3',
        },
      ]}
    />
  )
  return (
    <>
      <StyledFlex spaceBetween centerVertically isDisplay={true}>
        <Flex centerVertically>
          <IconWrapper>
            <PluginLiveLogo />
          </IconWrapper>
          <Divider />

          {!isOnboarding && (
            <HeaderInstituteInfo instituteData={instituteData} />
          )}
        </Flex>

        {!isOnboarding && (
          <FlexDiv centerVertically>
            {userData?.pluginlive_id && (
              <Flex centerVertically>
                <Button
                  type="primary"
                  icon={<IconFont type="icon-tuichu" />}
                  shape="round"
                  onClick={() => handleCheckout()}
                >
                  Checkout
                </Button>
              </Flex>
            )}
            <NotificationDiv
              onClick={() => {
                setNotification(true)
              }}
            >
              <NotificationIcon />
            </NotificationDiv>

            <Dropdown overlay={items} trigger={['click']}>
              <UserFlex>
                {CheckUserlogo(userData?.profile_picture, 40)}
                <Avatar
                  padding={'10px 0px 0px 0px'}
                  size={36}
                  src={<ArrowDown />}
                />
              </UserFlex>
            </Dropdown>
          </FlexDiv>
        )}
      </StyledFlex>
      <Notification
        notification={notification}
        setNotification={setNotification}
        getUserNotifications={getUserNotifications}
        notificationData={notificationData}
        markNotificationReadApi={markNotificationReadApi}
      />
    </>
  )
}
export default Header
